<template>
    <div>
        <section class='login reset-password-token'>
            <div class="flex-wrapper">
                <div class="content">
                    <div class="content-wrap">
                        <div class="group">
                          <router-link
                              class="menu-link"
                              :to="{name: 'public.login'}"
                          >
                            <img :src="logo" alt="Broodje dunner logo">
                          </router-link>
                        </div>

                        <div class="group">
                            <h3>Stel wachtwoord in</h3>
                        </div>

                        <PasswordResetTokenForm/>
                    </div>
                </div>

                <div class="image">
                    <img :src="image" alt="Login image for Broodje Dunner">
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PasswordResetTokenForm from "@/components/blocks/PasswordResetTokenForm.vue";
    import background from "@/assets/images/login-background.jpeg";
    import logo from "@/assets/images/logo.svg";
    import axios from "axios";

    export default {
        name: "PasswordResetToken",
        data() {
            return {
                image: background,
                logo: logo,
            };
        },
        components: {
            PasswordResetTokenForm,
        },
    };
</script>
